import { Trans, useTranslation } from 'react-i18next'

import {
  AFTER_ITEMS,
  BEFORE_ITEMS,
} from '~/pages/communication/beforeAfter/libs/components/BeforeAfterCommunication/constants'
import { Styles as S } from '~/pages/communication/beforeAfter/libs/components/BeforeAfterCommunication/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const BeforeAfterCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Something shifts when you follow through',
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ScrollContent>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationBeforeAfter.title"
            />
          </S.Title>

          <S.ComparisonWrapper>
            <S.Column>
              <S.ColumnHeaderPill>
                <Trans
                  ns="communication"
                  i18nKey="onboarding.communicationBeforeAfter.before"
                />
              </S.ColumnHeaderPill>

              <S.ItemList>
                {BEFORE_ITEMS.map(({ key, emoji }) => (
                  <S.Item key={key}>
                    <S.ItemEmoji>{emoji}</S.ItemEmoji>
                    <S.ItemText>
                      {t(
                        `onboarding.communicationBeforeAfter.beforeItems.${key}`,
                      )}
                    </S.ItemText>
                  </S.Item>
                ))}
              </S.ItemList>
            </S.Column>

            <S.Column $isAfter>
              <S.ColumnHeaderPill $isAfter>
                <Trans
                  ns="communication"
                  i18nKey="onboarding.communicationBeforeAfter.after"
                />
              </S.ColumnHeaderPill>

              <S.ItemList>
                {AFTER_ITEMS.map(({ key, emoji }) => (
                  <S.Item key={key} $isAfter>
                    <S.ItemEmoji>{emoji}</S.ItemEmoji>
                    <S.ItemText>
                      {t(
                        `onboarding.communicationBeforeAfter.afterItems.${key}`,
                      )}
                    </S.ItemText>
                  </S.Item>
                ))}
              </S.ItemList>
            </S.Column>
          </S.ComparisonWrapper>
        </S.ScrollContent>

        <S.ButtonWrapper>
          <S.Button type="button" onClick={() => handleContinue('')}>
            <Trans i18nKey="actions.continue" />
          </S.Button>
        </S.ButtonWrapper>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default BeforeAfterCommunication
